import { useState, useCallback, useEffect } from "react";

const storageName = "userData";

const useAuth = () => {
  const [token, setToken] = useState(null);
  const [ready, setReady] = useState(false);

  const login = useCallback((jwtToken) => {
    setToken(jwtToken);
    localStorage.setItem(storageName, JSON.stringify({ token: jwtToken }));
  }, []);

  const logout = useCallback(() => {
    setToken(null);
    localStorage.removeItem(storageName);
  }, []);

  useEffect(() => {
    try {
      const raw = localStorage.getItem(storageName);
      const data = raw ? JSON.parse(raw) : null;
      if (data && data.token) {
        login(data.token);
      }
    } catch (_) {
      // Private WebViews can block localStorage; continue without a cached token.
    }
    setReady(true);
  }, [login])

  return { login, logout, token, ready };
}

export default useAuth;